/**
 * Em dev, segue o host que serviu a página: VITE_API_URL aponta para
 * localhost, mas a página pode estar em 127.0.0.1 (previews de porta
 * efêmera) ou IP da LAN — "localhost" ali apontaria para a máquina errada
 * e cookies de sessão são por host.
 *
 * Página em domínio real (loc-*.9code.work, homologação): usa publicUrl
 * (VITE_API_URL_PUBLIC) — API cross-subdomain via HTTPS do Apache. Sem
 * publicUrl, o envUrl original vale (produção aponta para api real).
 * Um envUrl em rede privada (192.168/10/172.16-31) é a mesma situação:
 * nunca pode vazar para página em domínio real, pois quebra CORS/CSRF.
 */
const PRIVATE_HOST = /^(localhost|127\.0\.0\.1|192\.168\.\d+\.\d+|10\.\d+\.\d+\.\d+|172\.(1[6-9]|2\d|3[01])\.\d+\.\d+)$/

export function resolveApiBaseUrl(envUrl: string | undefined, publicUrl?: string, fallback = 'http://localhost:8000'): string {
  const url = new URL(envUrl ?? fallback)
  const pageHost = location.hostname
  if (url.hostname === pageHost) return url.origin
  if (PRIVATE_HOST.test(url.hostname)) {
    if (!PRIVATE_HOST.test(pageHost) && publicUrl) {
      return new URL(publicUrl).origin
    }
    url.hostname = pageHost
  }
  return url.origin
}
